import React, { useState, useEffect, useContext } from "react";
import { useHref, useNavigate, useLocation } from "react-router-dom";
import "../styles/login.css";
import ephLogo from "../images/logo-min.png";
import LoadingIcon from "../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { UrlContext } from "../contexts/UrlContext";
export default function Login() {
  useEffect(() => {
    document.title = "Login";
  }, []);
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("eph-token");
  const [loading, setLoading] = useState(false);
  const [userAccount, setUserAccount] = useState(null);
  const [userName, setUserName] = useState("");
  const { API_URL, URI } = useContext(UrlContext);
  useEffect(() => {
    if (isAuthenticated) {
      const [account] = instance.getAllAccounts();
      setUserAccount(account);
      setLoading(true);
      fetch(`${API_URL}create-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ idToken: account.idToken }),
      })
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          if (data.token) {
            const token = {
              value: data.token,
            };
            localStorage.setItem("eph-token", JSON.stringify(token));
            localStorage.setItem("timeout", Date.now() + 21600000);
            // navigate("/app/ProjectsOverview");
            const redirectPath = location.state?.redirectAfterLogin || "/app/ProjectsOverview";
            navigate(redirectPath);
          }
          if (data.status == "error") {
            Swal.fire({
              icon: "error",
              title: "Login Error",
              text: `${data.message}`,
              timer: 2000,
            });
          }
        })
        .catch((err) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Database connection error!",
            text: "Please try again.",
            confirmButtonText: "OK",
          });
        });
    }
    if (token) {
      navigate("/app/ProjectsOverview");
    }
  }, [isAuthenticated]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // microsoft validation
    instance.loginRedirect({
      scopes: ["User.Read"],
    });
    const [account] = instance.getAllAccounts();
    setUserAccount(account);
    setUserName(userAccount?.username);
    if (account) {
      fetch(`${API_URL}create-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ idToken: account.idToken }),
      })
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          if (data.token) {
            const token = {
              value: data.token,
            };
            localStorage.setItem("eph-token", JSON.stringify(token));
            localStorage.setItem("timeout", Date.now() + 21600000);
            navigate("/app/ProjectsOverview");
            window.dispatchEvent(new CustomEvent('eph-login-complete'));
          }
          if (data.status == "error") {
            Swal.fire({
              icon: "error",
              title: "Login Error",
              text: `${data.message}`,
              timer: 2000,
            });
          }
        })
        .catch((err) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Database connection error!",
            text: "Please try again.",
            confirmButtonText: "OK",
          });
        });
    }
  };

  return (
    <div className="eph-login-body">
      <div className="eph-login-wrapper fadeInDown">
        <div className="eph-login-formContent">
          <form onSubmit={handleSubmit}>
            <div className="fadeIn first">
              <img className="eph-login-logo" src={ephLogo} alt="EPH Logo" />
            </div>
            {!loading ? (
              <button type="submit" className="fadeIn fourth eph-loginbtn">
                Log In
              </button>
            ) : (
              <button className="fadeIn fourth eph-loginbtn" disabled={loading}>
                {" "}
                Wait..{" "}
              </button>
            )}
            {loading && (
              <img
                className="login-loading-icon"
                src={LoadingIcon}
                alt="Loading..."
              />
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
